import { Component, computed, effect, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsuarioService } from '@shared/services/usuario/usuario.service';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';

@Component({
  selector: 'app-user-dropdown',
  standalone: true,
  templateUrl: './user-dropdown.component.html',
    imports: [
    CommonModule,           
    RouterModule,           
    DropdownComponent,      
    DropdownItemTwoComponent
  ]
})
export class UserDropdownComponent {
  isOpen = false;
  perfilImageSrc: string | null = null;

  // Computed reactive para datos del perfil usando la signal directamente
  firstnameUSer = computed(() => this.usuarioService.perfil()?.firstname || 'Usuario');
  lastnameUSer = computed(() => this.usuarioService.perfil()?.lastname || 'Lastname');
  emailUser = computed(() => this.usuarioService.perfil()?.username || 'Sin Email');
  profileImageUrl = computed(() => this.usuarioService.perfil()?.profileImageUrl || 'assets/images/Partner-Core-No-Image.webp');

  // Effect para cargar imagen cuando el perfil cambie
  perfilEffect = effect(() => {
    const perfil = this.usuarioService.perfil();
    if (!perfil) return;
    
    this.cargarImagenPerfil();
  });

  constructor(
    private authService: AuthService,
    private usuarioService: UsuarioService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {
    this.usuarioService.getPerfil().subscribe();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  logout(): void {
    this.authService.logout('manual');
    this.router.navigate(['/auth/login']);
  }

  cargarImagenPerfil(): void {
    const profileUrl = this.usuarioService.perfil()?.profileImageUrl;

    if (!profileUrl || profileUrl === '' || profileUrl === 'images/user/owner.png') {
      this.perfilImageSrc = 'assets/images/Partner-Core-No-Image.webp';
      this.cd.markForCheck();
      return;
    }

    // Extraer userId y filename de la URL: /api/user/img/download/{userId}/{filename}
    const urlParts = profileUrl.split('/');
    const filename = urlParts[urlParts.length - 1];
    const userId = Number(urlParts[urlParts.length - 2]);

    this.usuarioService.getProfileImageBlob(userId, filename)
      .subscribe({
        next: (blob) => {
          if (this.perfilImageSrc) URL.revokeObjectURL(this.perfilImageSrc);
          this.perfilImageSrc = URL.createObjectURL(blob);
          this.cd.markForCheck();
        },
        error: () => {
          this.perfilImageSrc = 'assets/images/Partner-Core-No-Image.webp';
          this.cd.markForCheck();
        }
      });
  }
}